enum ViewOnlyFullAccessSecurity {
  no = 0,
  viewOnly = 1,
  fullAccess = 2,
}

export default ViewOnlyFullAccessSecurity;
